import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, XIcon } from 'lucide-react';
export function ForWhoSection() {
  const forWho = ['Eres mamá y tienes un negocio propio (físico o digital, no importa el tamaño)', 'Sientes que el tiempo se te va y no produces lo que quieres', 'Tu cerebro no "arranca" cuando te toca trabajar', 'Quieres resultados reales sin invertir horas que no tienes', 'Estás dispuesta a probar algo diferente durante 7 días', 'Quieres crecer en tu negocio sin sacrificar tu salud ni tu tiempo con tus hijos'];
  const notForWho = ['Buscas una fórmula mágica que haga el trabajo por ti', 'No estás dispuesta a dedicar 60 segundos al día a cambiar tu estado mental', 'Quieres resultados sin aplicar nada de lo que leerás', 'Ya tienes tu mente y tu energía perfectamente organizadas y solo necesitas más tiempo'];
  return <section className="w-full bg-[#FFF8F0] px-4 md:px-6 py-6 md:py-24 text-center" data-id="element-141">
      <div className="max-w-5xl mx-auto" data-id="element-142">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-143">
          <h2 className="font-['Playfair_Display'] text-2xl md:text-4xl lg:text-5xl font-bold text-[#2D2D2D] mb-5 md:mb-14" data-id="element-144">
            ¿Para quién es <span className="text-[#E8734A]" data-id="element-145">este manual?</span>
          </h2>

          <div className="grid md:grid-cols-2 gap-3 md:gap-8 text-left" data-id="element-146">
            {/* SÍ es para ti */}
            <div className="bg-white rounded-2xl md:rounded-3xl p-5 md:p-10 shadow-xl border-2 border-[#D4A853]/30 relative overflow-hidden" data-id="element-147">
              {/* Top accent bar */}
              <div className="absolute top-0 left-0 w-full h-1.5 bg-[#D4A853]" data-id="element-148" />

              <div className="text-center mb-4 md:mb-10" data-id="element-149">
                <div className="w-14 h-14 bg-[#D4A853]/15 rounded-full flex items-center justify-center mx-auto mb-3 md:mb-5" data-id="element-150">
                  <CheckIcon className="w-7 h-7 text-[#D4A853]" data-id="element-151" />
                </div>
                <h3 className="font-['Playfair_Display'] text-2xl md:text-3xl font-bold text-[#2D2D2D]" data-id="element-152">
                  Este manual <span className="text-[#D4A853]" data-id="element-153">SÍ</span> es para
                  ti si:
                </h3>
              </div>

              <div className="space-y-2 md:space-y-4" data-id="element-154">
                {forWho.map((item, index) => <motion.div key={index} initial={{
                opacity: 0,
                x: -20
              }} whileInView={{
                opacity: 1,
                x: 0
              }} viewport={{
                once: true
              }} transition={{
                duration: 0.4,
                delay: index * 0.08
              }} className="flex items-start gap-3 md:gap-4 bg-[#D4A853]/5 rounded-xl px-4 py-3 md:px-5 md:py-4 border border-[#D4A853]/10" data-id="element-155">
                    <div className="flex-shrink-0 w-7 h-7 rounded-lg bg-[#D4A853] flex items-center justify-center mt-0.5 shadow-sm" data-id="element-156">
                      <CheckIcon className="w-4 h-4 text-white" data-id="element-157" />
                    </div>
                    <p className="text-[#2D2D2D] leading-relaxed font-medium text-sm md:text-base" data-id="element-158">
                      {item}
                    </p>
                  </motion.div>)}
              </div>
            </div>

            {/* NO es para ti */}
            <div className="bg-white rounded-2xl md:rounded-3xl p-5 md:p-10 shadow-xl border border-[#F5E6DC] relative overflow-hidden" data-id="element-159">
              {/* Top accent bar */}
              <div className="absolute top-0 left-0 w-full h-1.5 bg-[#2D2D2D] opacity-20" data-id="element-160" />

              <div className="text-center mb-4 md:mb-10" data-id="element-161">
                <div className="w-14 h-14 bg-red-50 rounded-full flex items-center justify-center mx-auto mb-3 md:mb-5" data-id="element-162">
                  <XIcon className="w-7 h-7 text-red-400" data-id="element-163" />
                </div>
                <h3 className="font-['Playfair_Display'] text-2xl md:text-3xl font-bold text-[#2D2D2D]" data-id="element-164">
                  Este manual <span className="text-red-400 uppercase" data-id="element-165">NO</span>{' '}
                  es para ti si:
                </h3>
              </div>

              <div className="space-y-2 md:space-y-4 mb-4 md:mb-8" data-id="element-166">
                {notForWho.map((item, index) => <motion.div key={index} initial={{
                opacity: 0,
                x: -20
              }} whileInView={{
                opacity: 1,
                x: 0
              }} viewport={{
                once: true
              }} transition={{
                duration: 0.4,
                delay: index * 0.08
              }} className="flex items-start gap-3 md:gap-4 bg-red-50/50 rounded-xl px-4 py-3 md:px-5 md:py-4 border border-red-100" data-id="element-167">
                    <div className="flex-shrink-0 w-7 h-7 rounded-lg bg-red-400 flex items-center justify-center mt-0.5 shadow-sm" data-id="element-168">
                      <XIcon className="w-4 h-4 text-white" data-id="element-169" />
                    </div>
                    <p className="text-[#2D2D2D] leading-relaxed font-medium opacity-80 text-sm md:text-base" data-id="element-170">
                      {item}
                    </p>
                  </motion.div>)}
              </div>

              <div className="p-4 md:p-6 bg-[#FFF8F0] rounded-xl md:rounded-2xl text-center border border-[#F5E6DC]" data-id="element-171">
                <p className="text-sm text-[#2D2D2D] italic font-medium leading-relaxed" data-id="element-172">
                  Si eres de las últimas, honestamente no necesitas esto. Pero
                  si eres de las primeras,{' '}
                  <span className="font-bold text-[#E8734A] not-italic" data-id="element-173">
                    este manual fue escrito pensando en ti.
                  </span>
                </p>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}